import {
  Portal,
  Select,
  Separator,
  Text,
  createListCollection,
  useDisclosure,
} from '@chakra-ui/react';
import { FC } from 'react';
import { LuPlus } from 'react-icons/lu';
import { useNavigate, useParams } from 'react-router';
import CreateOrganizationModal from './CreateOrganizationModal';
import useSession from '../session/useSession';

const OrgSwitcher: FC = () => {
  const disclosure = useDisclosure();
  const session = useSession();
  const data = session.data;
  const params = useParams<{ orgSlug: string }>();
  const navigate = useNavigate();

  const frameworks = createListCollection({
    items:
      data?.organizations.map((org) => ({
        label: org.name,
        value: org.slug,
      })) ?? [],
  });

  const onChangeOrg = (details: { value: string[] }) => {
    const [value] = details.value;

    if (value === 'add') {
      disclosure.onOpen();
      return;
    }

    navigate(`/${value}`);
  };

  return (
    <>
      <Select.Root
        collection={frameworks}
        size="md"
        minWidth="150px"
        variant="subtle"
        value={[params.orgSlug ?? '']}
        onValueChange={onChangeOrg}
        positioning={{ placement: 'bottom', flip: false }}
      >
        <Select.HiddenSelect />
        <Select.Control>
          <Select.Trigger>
            <Select.ValueText placeholder="Select Organization" />
          </Select.Trigger>
          <Select.IndicatorGroup>
            <Select.Indicator />
          </Select.IndicatorGroup>
        </Select.Control>
        <Portal>
          <Select.Positioner>
            <Select.Content>
              {frameworks.items.map((framework) => (
                <Select.Item item={framework} key={framework.value}>
                  {framework.label}
                  <Select.ItemIndicator />
                </Select.Item>
              ))}
              <Separator my={2} />
              <Select.Item item={{ value: 'add', label: 'Create Organization' }}>
                <LuPlus />{' '}
                <Text fontWeight="medium">Create Organization</Text>
              </Select.Item>
            </Select.Content>
          </Select.Positioner>
        </Portal>
      </Select.Root>
      <CreateOrganizationModal
        isOpen={disclosure.open}
        onClose={disclosure.onClose}
        onSuccess={async (organization) => {
          await session.update?.();
          navigate(`/${organization.slug}`);
        }}
      />
    </>
  );
};

export default OrgSwitcher;
